import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Country, CountryState} from "@/modules/country/types";
import {getRawCountries} from "@/services/country";

export const state: CountryState = {
  countries: new Map(),
  rawCountries: []
}

const actions: ActionTree<CountryState, RootState> = {
  async GET_RAW_COUNTRIES() {
    return await getRawCountries();
  }
}

const mutations: MutationTree<CountryState> = {
  SET_RAW_COUNTRIES(state, rawCountries: Country[]) {
    state.rawCountries = rawCountries;
  }
}

const getters: GetterTree<CountryState, RootState> = {
  COUNTRIES(state): Map<string, Country> {
    const countriesMap = new Map();
    for (const country of state.rawCountries) {
      countriesMap.set(country.cca2, country);
    }
    return countriesMap;
  },
  RAW_COUNTRIES(state): Country[] {
    const {rawCountries} = state;
    return [...rawCountries]
  },
}

export const country: Module<CountryState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
